import React, { useCallback, useEffect, useLayoutEffect, useState } from "react";
import { FunctionComponent } from "react";
import { GetQueryParameter } from "../../Utilities/Url";
import {
  Provider,
  ThemeInput,
  teamsDarkTheme,
  teamsTheme,
} from "@fluentui/react-northstar";

interface ThemeProviderProps {
  children: React.ReactNode;
}

const ThemeProvider: FunctionComponent<ThemeProviderProps> = (props) => {
  const [currentTheme, setTheme] = useState<ThemeInput<any>>(teamsTheme);

  const updateTheme = useCallback((theme: string) => {
    document.body.setAttribute("data-theme", theme);
    if (theme === "dark") {
      setTheme(teamsDarkTheme);
    } else {
      setTheme(teamsTheme);
    }
  }, []);

  // Observe changes in the theme query parameter
  const observeThemeChanges = useCallback(() => {
    const queryTheme = GetQueryParameter("theme", "light");
    updateTheme(queryTheme);

    // Listen to URL changes (via popstate for back/forward navigation)
    const handlePopState = () => {
      const updatedTheme = GetQueryParameter("theme", "light");
      updateTheme(updatedTheme);
    };

    window.addEventListener("popstate", handlePopState);

    // Cleanup the listener on component unmount
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [updateTheme]);

  useEffect(() => {
    observeThemeChanges();
  }, [observeThemeChanges]);

  return (
    <Provider style={{ height: "100%", width: "100%" }} theme={currentTheme}>
      {props.children}
    </Provider>
  );
};

export default ThemeProvider;
